







import Contract, { CONTRACT_CUSTOMER_CONFIRM } from "@/model/contract";
import { Vue, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment/moment";
import {DATE_FORMAT} from "@/common/constant";

const authStore = namespace("Auth");

@Component({
  name: "CustomerStepLayout",
})
export default class CustomerStepLayout extends Vue {
  @authStore.Getter
  public getRole!: string;
  @authStore.Getter
  getCurrentyContract: Contract;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any, oldValue: any) {
    if (newValue && oldValue && newValue.name !== oldValue.name) {
      this.changedRoute++;
    }
    // if currenty contract no confirm redirect to intro page
    if (
      this.$router.currentRoute.matched[0].name === "customer" &&
      (this.getCurrentyContract.is_confirmed === CONTRACT_CUSTOMER_CONFIRM.WAIT
        && !!moment(moment().format(DATE_FORMAT)).isBefore(moment(this.getCurrentyContract.move_in_date).add(1, 'week').format(DATE_FORMAT)))
    ) {
      this.$router.push({
        name: "step.intro",
      });
    }
  }

  public changedRoute = 1;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  get classPage(): string[] {
    this.changedRoute; // hack to re-computed
    const initalClass = [];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    return initalClass;
  }

  get showBackBtn() {
    this.changedRoute; // hack to re-computed
    return this.$router.currentRoute.meta.root === undefined;
  }
  /**
   * goBack
   */
  public goBack() {
    const { step } = this.$router.currentRoute.query;

    if (step && step > "0") {
      let cStep = step.toString();
      // do not thing;
      this.$router.replace({
        query: { step: Number.parseInt(cStep) - 1 + "" },
      });
    } else {
      this.$router.push({
        name: "customer.home"
      });
    }
  }
}
